import { Component, Input, OnInit } from '@angular/core';
import { Recital } from 'models/page';

@Component({
  selector: 'ngx-pages-reciters-view-cell',
  templateUrl: './pages-reciters-view-cell.component.html',
  styleUrls: ['./pages-reciters-view-cell.component.scss']
})
export class PagesRecitersViewCellComponent implements OnInit {

  @Input() value: Recital[];

  constructor() {}
  ngOnInit(): void {}

  get Display(): string {
    return this.value.toString()
  }
}
